export default __webpack_public_path__ + "static/O0283-6559f164d3e2f9d8de96230ed8d0a7ba.png";